module.exports = __webpack_public_path__ + "static/media/gs.6b4bf37b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gs.svg
// module id = 135
// module chunks = 0